export async function authFetch(url, options = {}) {
  // 1. Read token freshly every time
  const tokenString = localStorage.getItem("authToken");

  let headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  if (tokenString) {
    try {
      const token = JSON.parse(tokenString);
      if (token?.access) {
        headers.Authorization = `Bearer ${token.access}`;
      }
    } catch (err) {
      console.warn("Token parse error:", err);
    }
  }

  // 2. If we still don't have token → block request
  if (!headers.Authorization) {
    console.warn("authFetch blocked: No token yet.");
    return { ok: false, status: 401 };
  }

  // 3. Actual fetch
  const response = await fetch(url, {
    ...options,
    headers,
  });

  // 4. If token expired (401), handle auto refresh here if needed
  if (response.status === 401) {
    console.warn("Token expired — you may refresh token here");
  }

  return response;
}
